import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import cx from 'classnames';
import { FormattedMessage as T } from 'react-intl';
import TrustPilotStars from './TrustPilotStars';
import { getLabel } from './getLabel';
import WhiteLogo from './trustpilot-logo-white.svg';
import BlackLogo from './trustpilot-logo.svg';

type TrustPilotRatingProps = {
  rating: number;
  url: string;
  shortText?: string;
};

const TrustPilotRating = ({
  rating,
  url,
  shortText,
}: TrustPilotRatingProps) => {
  const config = useGlobalConfig();
  const storefrontV2Enabled = config.BU_CONFIG.STOREFRONT_V2_ENABLED;

  return (
    <div
      className={cx(
        'm-auto flex w-min flex-col gap-2 rounded-full px-10 py-3 text-lg min-[800px]:p-0 md:text-xl lg:m-0 lg:w-full',
        {
          'bg-white': !storefrontV2Enabled,
        },
      )}
    >
      <a
        href={url}
        className={cx(
          'flex items-center justify-center gap-3 min-[800px]:px-0 lg:justify-start',
          {
            'text-white': storefrontV2Enabled,
          },
        )}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="text-sm font-medium min-[800px]:hidden lg:block lg:text-lg">
          <T {...getLabel(rating)} />
        </span>
        <TrustPilotStars rating={rating} />
        <span className="-mt-1">
          {storefrontV2Enabled ? <WhiteLogo /> : <BlackLogo />}
        </span>
      </a>
      {shortText && (
        <a
          href={url}
          className={cx(
            'text-center text-xs min-[800px]:hidden lg:block lg:text-left lg:text-base',
            {
              'text-blue-100/60': !storefrontV2Enabled,
              'text-white': storefrontV2Enabled,
            },
          )}
          target="_blank"
          rel="noopener noreferrer"
        >
          {shortText}
        </a>
      )}
    </div>
  );
};

export default TrustPilotRating;
